import {createAsyncThunk} from '@reduxjs/toolkit';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {RootState} from 'common/src/redux/store';
import aiContentItemApi from '../../../aiContentItem.api';
import {UpdateAiContentItemRequest} from '../../../aiContentItem.types';
import {setItems, setItemsError, setItemsLoading} from '../aiContentProject.slice';

type UpdateItemParams = {id: number; request: UpdateAiContentItemRequest};

const updateAiContentItems = createAsyncThunk<void, UpdateItemParams[], {state: RootState}>(
  `${BreadcrumbName.AiContentProjectPage}/updateAiContentItems`,
  async (updates, {dispatch, getState, rejectWithValue}) => {
    if (updates.length === 0) {
      return;
    }

    const state = getState();
    const stateItems = state.aiContentProjectPage?.items ?? [];

    const firstItem = stateItems.find((item) => item.id === updates[0].id);
    const projectId = firstItem?.projectId;

    if (!projectId) {
      return rejectWithValue('Item not found');
    }

    dispatch(setItemsLoading(true));
    dispatch(setItemsError(null));

    try {
      await Promise.all(
        updates.map(({id, request}) => aiContentItemApi.updateAiContentItem({id, request})),
      );

      const items = await aiContentItemApi.getAiContentItemsByProjectId(projectId);
      dispatch(setItems(items));
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Failed to update items';
      dispatch(setItemsError(errorMessage));

      return rejectWithValue(errorMessage);
    } finally {
      dispatch(setItemsLoading(false));
    }
  },
);

export default updateAiContentItems;
